import AddPostLinkModalBody from './AddPostLinkModalBody';

const AddLinkToPostWithSearchPlugin = {
  reducer: {},
  bodyComponent: AddPostLinkModalBody,
};

export default AddLinkToPostWithSearchPlugin;
